import { useQueryClient } from "@tanstack/react-query";
import { Skeleton, Typography, Flex } from "antd";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import Page from "~Common/Page";
import { LogoUploadModal } from "~Features/Organizations/components/LogoUploadModal/LogoUploadModal.tsx";
import { useFetchOrganization } from "~entities/api";
import { ImageTypes } from "~enums/imageTypes.ts";

type Props = {
  children: ReactNode;
};

const ManageOrganizationsWrapper = ({ children }: Props) => {
  const { formatMessage } = useIntl();
  const { data, isPending } = useFetchOrganization();
  const queryQlient = useQueryClient();

  const { sport, organizationId } = useParams();

  const titleText = `${formatMessage({
    id: "manage",
    defaultMessage: "Manage",
  })} - ${data?.nameLocal}`;

  const tabTitle = formatMessage(
    { id: "pageTitles.organization.manageOrganization" },
    { organizationName: data?.nameLocal },
  );

  if (isPending) {
    return <Skeleton />;
  }

  return (
    <Page
      tabTitle={tabTitle}
      title={
        <Flex align="center" gap={26}>
          <LogoUploadModal
            refetch={() => {
              queryQlient.invalidateQueries({ queryKey: ["organization", sport, organizationId] });
            }}
            organizationId={data?.organizationId}
            currentLogo={data?.images?.find((image) => image.imageType === ImageTypes.Logo)}
          />
          <Typography.Title level={2} style={{ marginBottom: 0, marginTop: 0 }}>{titleText}</Typography.Title>
        </Flex>
      }
    >
      {children}
    </Page>
  );
};

export default ManageOrganizationsWrapper;
